import Container from "components/general/Container";
import { Box, Button, HStack, Text, Typography } from "components/ui";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

export const PageMetrics = ({ background }: { background?: string }) => {
	const isMobile = useIsMobile();

	if (isMobile) {
		return (
			<Box bg={background || "transparent"} flexDirection="column-reverse" paddingVertical={20} paddingHorizontal={12}>
				<Box gap={24}>
					<Text style={{ fontWeight: "700", fontSize: 20, lineHeight: 26 }}>We empower commercial cleaners by taking out the complexity in cleaning and utilising effective, innovative technology, equipment and products.</Text>
					<Box alignItems="flex-start">
						<Button isLink href={"/about-us"} variant="secondary">
							<Typography weight="bold">About Abco</Typography>
						</Button>
					</Box>
				</Box>
				<Box>
					<Box gap={24} p={32} bg={"$darkbluexlight"} borderRadius={12} marginVertical={32}>
						<HStack justifyContent="space-evenly">
							<Box flex={1}>
								<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>50+</Text>
								<Text style={{ flex: 1, fontWeight: "700" }}>years of experience</Text>
							</Box>
							<Box flex={1}>
								<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>300+</Text>
								<Text style={{ flex: 1, fontWeight: "700" }}>five star reviews</Text>
							</Box>
						</HStack>
						<HStack justifyContent="space-evenly">
							<Box flex={1}>
								<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>8</Text>
								<Text style={{ flex: 1, fontWeight: "700" }}>Locations</Text>
							</Box>
							<Box flex={1}>
								<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>98.5%</Text>
								<Text style={{ flex: 1, fontWeight: "700" }}>fill rate on core lines</Text>
							</Box>
						</HStack>
					</Box>
				</Box>
			</Box>
		);
	}
	return (
		<Box bg={background || "transparent"}>
			<Container>
				<Box maxWidth={1024} mx="auto" gap={24} paddingVertical={20} flexDirection="row" paddingHorizontal={12} marginVertical={24}>
					<Box flex={1} justifyContent="center" alignItems="center">
						<Box paddingHorizontal={40}>
							<Text style={{ fontWeight: "700", marginBottom: 24, fontSize: 20, lineHeight: "130%" }}>
								We empower commercial cleaners by taking out the complexity in cleaning and utilising effective, innovative technology, equipment and products.
							</Text>
							<Box alignItems="flex-start">
								<Button isLink href={"/about-us"} variant="secondary">
									<Typography weight="bold">About Abco</Typography>
								</Button>
							</Box>
						</Box>
					</Box>

					<Box flex={1}>
						<Box gap={24} p={48} bg={"$darkbluexlight"} minHeight={300} borderRadius={12} marginVertical={32}>
							<HStack flex={1} gap={48} justifyContent="space-evenly">
								<Box flex={1}>
									<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>50+</Text>
									<Text style={{ flex: 1, fontWeight: "700" }}>years of experience</Text>
								</Box>
								<Box flex={1}>
									<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>300+</Text>
									<Text style={{ flex: 1, fontWeight: "700" }}>five star reviews</Text>
								</Box>
							</HStack>
							<HStack flex={1} gap={48} justifyContent="space-evenly">
								<Box flex={1}>
									<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>8</Text>
									<Text style={{ flex: 1, fontWeight: "700" }}>Locations</Text>
								</Box>
								<Box flex={1}>
									<Text style={{ flex: 1, fontWeight: "700", fontSize: 40 }}>98.5%</Text>
									<Text style={{ flex: 1, fontWeight: "700" }}>fill rate on core lines</Text>
								</Box>
							</HStack>
						</Box>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};
